export const nameList = {
  Dragonborn: ["Clophad", "Ardun", "Dimmis", "Fankar", "Luldrid", "Thexish"],
  Dwarf: ["Dalduhr", "Rotdrus", "Bunnik", "Jinglia", "Nassleil", "Gymnyss"],
  Elf: ["Farydark", "Adbalar", "Olowarin", "Sylna", "Trisgwyn", "Xilgella"],
  Gnome: ["Inagyra", "Orfyx", "Grenmila", "Ianji", "Niros", "Nexfiz"],
  "Half-Elf": ["Norlamir", "Corros", "Walfyr", "Iroseris", "Sylmythe", "Hoyra"],
  "Half-Orc": ["Doradar", "Sarudak", "Hunadall", "Kani", "Fulenur", "Zeninar"],
  Halfling: ["Wilster", "Ricdal", "Vinpos", "Yesna", "Brena", "Xansira"],
  Human: ["Sezud", "Breldurk", "Strondoth", "Nazotil", "Lozzezan", "Hidrarlu"],
  Tiefling: ["Sallius", "Rexire", "Moremon", "Arisolis", "Yuvine", "Zaicria"],
};
